import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { IncidentEmailModel } from "../models/incident-email.model";
import { PaginatedResult } from "@app/shared/models/Generic/paginated-result";
import { SortDirection } from "@angular/material/sort";

@Injectable({
    providedIn: "root",
})
export class IncidentEmailsService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/emails`;

    public getEmails(
        offset: number,
        count: number,
        sortBy?: string,
        sortDirection?: SortDirection,
        search?: string
    ): Observable<PaginatedResult<IncidentEmailModel>> {
        let params = new HttpParams();

        if (search) {
            params = params.append("search", search);
        }

        params = params.append("offset", offset);
        params = params.append("count", count);
        params = params.append("sortBy", sortBy);
        params = params.append("sortAscending", sortDirection === "asc");

        return this.httpClient.get<PaginatedResult<IncidentEmailModel>>(this.baseUrl, {
            params: params,
        });
    }
}
